import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'HourFilter'})
export class HourFilter implements PipeTransform {
  transform(value: string): string {    
    if (value === undefined || value == null) {
      return '';
    } else if (value.indexOf(':') == 1) {
      if (value.length == 3) {
        return '0' + value.substr(0, 1) + ':' + '0' + value.substr(2, 2);
      } else {
        return '0' + value.substr(0, 1) + ':' + value.substr(2, 2);
      }
    } else {
      if (value.indexOf(':') == 2) {
        return (value.length == 4) ? (value.substr(0, 2) + ':' + '0' + value.substr(3, 1)) : value;
      } else {
        return (value.length == 4) ? (value.substr(0, 2) + ':' + value.substr(2, 2)) : value;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/pipes/hour.pipe.ts